import { useRouter } from 'next/router';
import { memo, useCallback } from 'react';
import { ArticleTileSizes, IArticleCard } from '@bridebook/web/app-shared/lib/articles/types';
import { getTagName } from '@bridebook/web/lib/articles/utils';
import { decodeEntities } from '@bridebook/web/app-shared/lib/utils';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import ArticleTile from './article-tile';

interface IProps {
  article: IArticleCard;
  cutTitle?: number;
  cutTitleMobile?: number;
  imageWidth?: number;
  imageHeight?: number;
  hideCategory?: boolean;
  hideBookmark?: boolean;
  size?: ArticleTileSizes;
  index?: number;
  firstArticle?: boolean;
}

const BlockArticle = ({
  article,
  imageWidth,
  imageHeight,
  hideCategory,
  hideBookmark,
  size,
  index,
  firstArticle,
}: IProps) => {
  const router = useRouter();

  const { articlePath } = article;
  const imageLink = article.img;
  const title = decodeEntities(article.title);

  const tags = article.tags
    .filter((s) => s !== 'all')
    .map((s) => ({ slug: s, name: getTagName(s) }))
    .filter((tag) => !!tag.name);

  const onToggleBookmark = useCallback(() => {
    router.push(UrlHelper.signup);
  }, [router]);

  imageWidth = imageWidth || (size === 'small' ? 85 : 251);
  imageHeight = imageHeight || (size === 'small' ? 65 : 191);

  return (
    <ArticleTile
      {...{
        title,
        isBookmarked: false,
        onToggleBookmark,
        size,
        imageLink,
        imageWidth,
        imageHeight,
        hideCategory,
        hideBookmark,
        articlePath,
        index,
        firstArticle,
        tags,
        date: article.date,
        description: article.description,
        categorySlug: article.categorySlug,
      }}
    />
  );
};

export default memo(BlockArticle);
